import styled from 'styled-components';

export const MobileAppResetPasswordStyled = styled.div`
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;
    padding: 16px;
    margin-bottom: 80px;
    text-align: center;
    
    .reset-password-content__password {
        margin-top: 24px;
    }
    .reset-password-content__password-confirm {
        margin-top: 24px;
    }
    .reset-password-content__submit-button {
        margin-top: 24px;
    }
`;
